import React from 'react';
import moment from 'moment';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import Modal from 'react-modal';
import { useSelector } from 'react-redux';
import { patientDetailsStyles } from '../../../theme/style';
import { urls } from '../../../utils/Objects';
import MyLink from '../../common/MyLink';
import ImgCarousel from './ImgCurosel';
import { base64String } from '../../../utils/CFuncs';

export default function PersonalInfo({ diagnoseInd, peronalInfo = {}, handleUpdateInfo, info, settings }) {
  const { selectedPatient, patient } = useSelector((state) => state.user);
  const { imageUrls } = patient;
  console.log({ patient });

  console.log(`%c ${JSON.stringify(peronalInfo)}`, `color: green ; font-size:15px`);
  return (
    <div>
      <div style={patientDetailsStyles.patientName}>
        {peronalInfo?.firstName + ' ' + peronalInfo?.lastName} <br />
      </div>

      <a href={`mailto:${peronalInfo?.email}`}>{peronalInfo?.email}</a>
      <div className="row">
        <div style={patientDetailsStyles.startDate}>Birth Date &nbsp;</div>
        <span>{moment(peronalInfo?.birthDate).format('MMM D, YYYY')}</span>
      </div>
      <div
        style={styles.button}
        onClick={() => {
          handleUpdateInfo(!info);
        }}
      >
        Other Contact Information
      </div>

      <Modal
        style={{
          content: { ...styles.centerModal },
        }}
        ariaHideApp={false}
        isOpen={info}
        onRequestClose={() => handleUpdateInfo(false)}
        contentLabel="Example Modal"
      >
        <div style={styles.container}>
          <AiOutlineCloseCircle style={styles.closeButton} onClick={() => handleUpdateInfo(false)} />

          <div style={styles.title}>Patient Info</div>
          <div style={styles.insideContainer}>
            <div>{`Adress ${peronalInfo?.address}`}</div>
            <div>{`Phone ${peronalInfo?.phoneNumber}`}</div>
          </div>
        </div>
      </Modal>

      {/* Carousel */}
      <ImgCarousel diagnosisInd={diagnoseInd} />

      <div className="row">
        <div style={patientDetailsStyles.startDate}>Device Serial Number &nbsp;</div>
        <span>{settings ? settings.cobbSerialNumber : 'No Device Connected'}</span>
      </div>

      <MyLink pathname={urls.patientTransfers} state={selectedPatient}>
        Data Transfer
      </MyLink>
    </div>
  );
}

const styles = {
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    width: '30px',
    height: '30px',
    cursor: 'pointer',
  },
  centerModal: {
    width: 600,
    height: 600,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  insideContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    // border: '1px solid'
  },
  title: {
    position: 'relative',
    top: -50,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 40,
  },
  button: {
    cursor: 'pointer',
    backgroundColor: '#4CAF50',
    border: 'none',
    color: 'white',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
};
